// extracted by mini-css-extract-plugin
module.exports = {"tabColumn":"tabs__tabColumn__lVmPM","tab":"tabs__tab__QhdEa","active":"tabs__active__jOe4P","body":"tabs__body__vpqRX"};